import React from 'react';
import { observer, inject } from 'mobx-react';
import styled from 'styled-components';

import { Box, TextInput } from 'grommet';

import customTheme from 'app/style/theme';

const Input = styled(TextInput)`
  background: ${customTheme.global.colors['accent-3']};
  border: 2px solid ${customTheme.global.colors['dark-1']};
  :focus {
    color: ${customTheme.global.colors.text};
    background: ${customTheme.global.colors['accent-2']};
    border: 1px solid ${customTheme.global.colors.focus};
    box-shadow: 0 0 1px 1px ${customTheme.global.colors.focus};
    outline: none !important;
  }
  @media (max-width: 600px) {
    height: 32px;
  }
`;

class SearchInput extends React.Component {
  constructor(props) {
    super(props);
    this.onSubmit = this.onSubmit.bind(this);
    this.onChange = this.onChange.bind(this);
    this.onFocus = this.onFocus.bind(this);
    this.onBlur = this.onBlur.bind(this);
    this.state = {
      searchTerm: '',
      tempSearchTerm: '',
    };
  }

  onSubmit(keypress) {
    const { AppState } = this.props;
    const { searchTerm } = this.state;
    if (keypress === 'Enter') {
      AppState.changeSearchStatus('SEARCH_RESULTS_PENDING');
      AppState.newSearchTerm(searchTerm);
      // this.setState({ searchTerm: '' });
    }
  }

  onChange(searchTerm) {
    this.setState({ searchTerm, tempSearchTerm: searchTerm });
  }

  onFocus() {
    this.setState({ searchTerm: '' });
  }

  onBlur() {
    const { tempSearchTerm } = this.state;
    this.setState({ searchTerm: tempSearchTerm });
  }

  render() {
    const { AppState } = this.props;
    const { searchTerm } = this.state;
    if (!AppState.isUserSearching) return null;
    return (
      <Box
        pad="xsmall"
        basis="1/2"
        justify="start"
        align="center"
        flex="shrink"
        fill="horizontal"
      >
        <Input
          focusIndicator
          autoFocus={!AppState.hasSearchResults}
          value={searchTerm}
          onChange={event => this.onChange(event.target.value)}
          onFocus={this.onFocus}
          onBlur={this.onBlur}
          onKeyPress={event => this.onSubmit(event.key)}
        />
      </Box>
    );
  }
}

export default inject('AppState')(observer(SearchInput));



// WEBPACK FOOTER //
// ./src/app/components/MainMenu/SearchInput.js